import { zodResolver } from '@hookform/resolvers/zod';
import { AircraftType } from '@pelicargo/types';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { TrpcInputs, TrpcOutputs } from '../../config/trpc';

export type InstructionInput = NonNullable<TrpcInputs['createInstruction']>;

export type InstructionOutput = TrpcOutputs['createInstruction'];

type UseInstructionForm = { methods: UseFormReturn<InstructionInput> };

export const address = z.object({
  recipient: z.string().nullish(),
  line_one: z.string().nullish(),
  line_two: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  zip_code: z.string().nullish(),
  country: z.string().nullish(),
});

export const validationSchema = z.object({
  name: z.string().optional(),
  aircraft_type: z
    .any()
    .transform((value) => (!value ? undefined : value))
    .pipe(z.nativeEnum(AircraftType).optional()),

  provider_id: z.string(),
  airport_id: z.string(),

  delivery_address: address.optional(),
  booking_instructions: z.string().optional(),
  dropoff_contact_id: z.number().optional(),
  dropoff_instructions: z.string().optional(),
  from_dock_hours: z.coerce.number().nullish(),
  to_dock_hours: z.coerce.number().nullish(),
});

export const useInstructionForm = (data?: Partial<InstructionInput>): UseInstructionForm => {
  const { reset, getValues, setValue, ...methods } = useForm<InstructionInput>({
    mode: 'onBlur',
    resolver: zodResolver(validationSchema),
    defaultValues: { ...data },
  });

  return { methods: { ...methods, getValues, setValue, reset } };
};
